module.exports = __webpack_public_path__ + "media/packs/images/note-7e87bed513cb1f1e349dde839edf2202.svg";